import React from "react";
import { Select } from "antd";
import { MaterialSymbol } from "react-material-symbols";
import iconsData from "@material-symbols/metadata/versions.json";
import type { MaterialSymbolProps } from "react-material-symbols";


import "./IconSelector.scss";
import { t } from "i18next";

interface IconSelectorProps {
  value?: MaterialSymbolProps["icon"];
  onChange: (iconName: MaterialSymbolProps["icon"]) => void;
}

const icons: MaterialSymbolProps["icon"][] = Object.keys(iconsData) as MaterialSymbolProps["icon"][];

const IconSelector: React.FC<IconSelectorProps> = ({ value, onChange }) => {
  const options = icons.map(iconName => ({
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <MaterialSymbol icon={iconName} size={20} />
        <span>{iconName}</span>
      </div>
    ),
    value: iconName
  }));

  return (
    <div className="icon-selector">
      <Select<MaterialSymbolProps["icon"]>
        showSearch
        placeholder={t("components.icon.select-icon")}
        value={value}
        onChange={onChange}
        style={{ width: "100%" }}
        filterOption={(input, option) =>
          (option?.value?.toString() ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={options} // 🔹 Usamos la propiedad options
      />

      {/* Vista previa del icono seleccionado */}
      {value && (
        <div className="icon-selector__preview" style={{ marginTop: 16 }}>
          <MaterialSymbol icon={value} size={48} />
        </div>
      )}
    </div>
  );
};

export default IconSelector;
